import React from 'react';
import Template from '../../component/Template.js';
import Api from '../../component/Api';
import { useEffect, useState, useRef } from 'react';
import html2pdf from "html2pdf.js";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PdfTemplate from '../../component/Print.js'; // Import the PdfTemplate component
import ReactDOMServer from 'react-dom/server';

export default function CourseInCollege() {

  const { http } = Api();
  const collegename = localStorage.getItem('username');

  const [deactiveTab, setdeActiveTab] = useState([]);
  const [department, setDepartment] = useState(3);
  const [admissionYear, setAdmissionYear] = useState(2024);
  const [semester, setSemester] = useState(1);
  const [data, setData] = useState({});
  const [date, setdate] = useState(false);
  const [bvocData, setBvocData] = useState({});
  const [date1, setdate1] = useState(false);

  const templateRef = useRef();

  //ACTIVE PRINT FUNCTION 1
  const handleGeneratePrintPDF = async () => {
    const element = (
      <PdfTemplate data={data} bvocData={bvocData} department={department} semester={semester} date={date} admissionYear={admissionYear} />
    );
    const pdfElement = document.createElement('div');
    pdfElement.innerHTML = ReactDOMServer.renderToStaticMarkup(element);

    const config = {
      margin: [40, 20, 60, 20], // Increased top and bottom margins
      filename: `${collegename}_course_list.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        letterRendering: true,
        scrollY: -window.scrollY,
      },
      jsPDF: {
        unit: 'pt',
        format: 'a4',
        orientation: 'portrait',
        compressPDF: true
      },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
    };

    html2pdf().from(pdfElement).set(config).toPdf().get('pdf').then((pdf) => {
      const totalPages = pdf.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.setTextColor(88, 31, 55); // #581F37 in RGB

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // Add a straight line above the footer
        pdf.setDrawColor(88, 31, 55); // #581F37 in RGB
        pdf.setLineWidth(0.5); // Set line width
        pdf.line(20, pageHeight - 30, pageWidth - 20, pageHeight - 30);

        // Add footer text
        pdf.setFont("helvetica", "normal");
        pdf.text("© Mahatma Gandhi University,Priyadarsini Hills, Kottayam, Kerala, India - 686560", pageWidth / 2, pageHeight - 20, { align: "center" });
        pdf.text(date, pageWidth / 2, pageHeight - 5, { align: "center" });

        // Add page numbers
        pdf.text(`Page ${i} of ${totalPages}`, pageWidth - 40, 30, { align: "right" });
      }
    }).save();
  };
  // ACTIVE PRINT FUNCTION 2

  const handleGeneratePDF = () => {
  
    const printContent = document.getElementById('printarea').innerHTML;
    const printWindow = window.open('', '', 'height=1000,width=1000');

    // Custom styles for the print page
    const styles = `
    <style>
      body {
        font-family: Arial, sans-serif !important;
      }
      h2 {
        text-align: center !important;
        font-size: 24px !important;
        margin-bottom: 20px !important;
        color: #007bff !important; /* Example color for heading */
      }
      table {
        width: 100% !important;
        border-collapse: collapse !important;
        margin: 20px 0 !important;
      }
      th, td {
        padding: 12px !important;
        text-align: left !important;
        border-bottom: 1px solid #ddd !important;
      }
      th {
        background-color: #f2f2f2 !important;
        color: #333 !important; /* Example color for table header text */
      }
      tr:nth-child(even) {
        background-color: #f9f9f9 !important;
      }
      tr:nth-child(odd) {
        background-color: #ffffff !important;
      }
    </style>
  `;

    printWindow.document.write('<html><head><title>Print</title>');
    printWindow.document.write('<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" />');
    printWindow.document.write(styles);
    printWindow.document.write('</head><body>');

    // Add a heading above the content
    printWindow.document.write(`<h2>Courses Offered in ${collegename}</h2>`);

    // Use a wrapper with inline styles for the print content
    printWindow.document.write(`
    <div style="margin: 20px;">
      ${printContent}
    </div>
  `);

    printWindow.document.write('</body></html>');

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };



  const toggleTab = (tab) => {
    setdeActiveTab(tabs => {
      if (tabs.includes(tab)) {
        return tabs.filter(t => t !== tab);
      } else {
        return [...tabs, tab];
      }
    });
  };

  useEffect(() => {
    const fetch = () => {
      http.get('Admin/listcollegecourses', {
        params: {
          semester_id: semester,
          department: department,
          admissionYear: admissionYear
        }
      })
        .then(Result => {

          if (Result.data.status_code === "ERR5") {
            setData(false);
          } else {
            setData(Result.data.processedCourses);
            setdate(Result.data.date);

          }
        })
        .catch(error => {
          console.log("error=", error);
          toast.error("something went wrong");
        });
    }

    if (department && semester, admissionYear) {
      fetch();
    }

  }, [department, semester, admissionYear]);

  useEffect(() => {
    const listCollegeBvocCourses = () => {
      http.get('/Admin/listCollegeBvocCourses', {
        params: {
          semester_id: semester,
          department: department,
          admissionYear: admissionYear
        }
      }).then((response) => {
 
        if (response.data.status_code === "ERR5") {
          setBvocData(false);
        } else {
          setBvocData(response.data.processedBvocCourses);
          setdate1(response.data.date);

        }
      }).catch(error => {

        toast.error("something went wrong");
      });
    }
    if (department && semester, admissionYear) {
      listCollegeBvocCourses();
    }

  }, [department, semester, admissionYear]);

  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="card">
                <div className="card-header card-heading">
                  <div className="py-3 d-flex justify-content-between align-items-center">
                    <h5 className="lbl1">Courses Offered in College</h5>
                    <div className="buttons-container">

                      <button
                        className="lbl2 btn btn-primary m-r-10"
                        onClick={handleGeneratePrintPDF}
                        title="Download"
                      >
                        <i class="bi bi-arrow-down-square"></i>
                      </button>

                      <button
                        className="lbl2 btn btn-primary"
                        onClick={handleGeneratePDF}
                        title="Print PDF"
                      >
                        <i className="bi bi-printer"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4 col-xl-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="exampleFormControlSelect11">Admission Year</label>
                        <select className="form-control form-select scrollable-bar-select" id="exampleFormControlSelect11" onChange={(e) => setAdmissionYear(e.target.value)}>
                          <option value={2024}>2024</option>
                          <option value={2025}>2025</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4 col-xl-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="exampleFormControlSelect12">Semester</label>
                        <select className="form-control form-select scrollable-bar-select" id="exampleFormControlSelect12" onChange={(e) => setSemester(e.target.value)}>
                          <option value={1}>1</option>
                          <option value={2}>2</option>
                          <option value={3}>3</option>
                          <option value={4}>4</option>
                          <option value={5}>5</option>
                          <option value={6}>6</option>
                          <option value={7}>7</option>
                          <option value={8}>8</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4 col-xl-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="exampleFormControlSelect13">Discipline</label>
                        <select className="form-control form-select scrollable-bar-select" id="exampleFormControlSelect13" onChange={(e) => setDepartment(e.target.value)}>
                          <option value={3}>All</option>
                          <option value={2}>College Disciplines</option>
                          <option value={1}>Single Faculty Disciplines</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div id="printarea">

                    {data && Object.keys(data).length > 0 && (
                      <div className="course-heading">
                        <h5>Courses</h5>
                      </div>
                    )}
                    <div className="accordion dark-accordion" id="outlineaccordion" ref={templateRef}>
                      <div className="accordion-item accordion-wrapper">
                        {data ? (Object.keys(data).map((subject, index) => (
                          <div className="acodn-bot-line" key={index}>
                            <h2 className="accordion-header">
                              <button
                                className={`accordion-button txt-primary accordion-light-primary`}
                                type="button"
                                onClick={() => toggleTab(subject)}
                              >
                                {subject} &nbsp;&nbsp;
                                {department != 3 ? (
                                  <>
                                    <i className="fa fa-minus" aria-hidden="true"></i>&nbsp;&nbsp;
                                    {data[subject][0].dept === 'college_dept' ? 'College Disciplines' : 'Single Faculty Disciplines'}
                                  </>
                                ) : null}
                                <i className={`${deactiveTab.includes(subject) ? 'bi bi-chevron-down svg-color' : 'bi bi-chevron-up svg-color'}`}></i>
                              </button>
                            </h2>
                            <div
                              className={`accordion-collapse collapse ${deactiveTab.includes(subject) ? '' : 'show'}`}
                              data-bs-parent="#outlineaccordion"
                            >
                              <div className="accordion-body">
                                <div className="table-responsive signal-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr className="table-active">
                                        <th scope="col" width="10%">Course Code</th>
                                        <th scope="col" width="20%">Course</th>
                                        <th scope="col" width="15%">Faculty</th>
                                        <th scope="col" width="10%">Discipline</th>
                                        <th scope="col" width="10%">Course Category</th>
                                        <th scope="col" width="15%">Course Type</th>
                                        {department == 3 ? (
                                          <th scope="col" width="15%">Discipline Type</th>
                                        ) : null}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Array.isArray(data[subject]) ? (
                                        data[subject].map((course, courseIndex) => (
                                          <tr key={courseIndex}>
                                            <td>{course.course_code}</td>
                                            <td>{course.course_name}</td>
                                            <td>{course.faculty_name}</td>
                                            <td>{course.discipline_name}</td>
                                            <td>{course.group_name}</td>
                                            <td>{course.college_course_type}</td>
                                            {department == 3 ? (
                                              <td>{course.dept === 'college_dept' ? 'College Disciplines' : 'Single Faculty Disciplines'}</td>
                                            ) : null}
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="3">No courses available for this subject</td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))) : (
                          <div className="txt-aln pdg11">course data  not found</div>
                        )}
                      </div>
                    </div>

                    {bvocData && Object.keys(bvocData).length > 0 && (
                      <div className="course-heading">

                        <h5>B.Voc</h5>
                      </div>
                    )}

                    <div className="accordion dark-accordion m-t-10" id="outlineaccordion" ref={templateRef}>
                      <div className="accordion-item accordion-wrapper">
                        {bvocData ? (Object.keys(bvocData).map((subject, index) => (
                          <div className="acodn-bot-line" key={index}>
                            <h2 className="accordion-header">
                              <button
                                className={`accordion-button txt-primary accordion-light-primary`}
                                type="button"
                                onClick={() => toggleTab(subject)}
                              >
                                {subject} &nbsp;&nbsp;
                                {department != 3 ? (
                                  <>
                                    <i className="fa fa-minus" aria-hidden="true"></i>&nbsp;&nbsp;
                                    {bvocData[subject][0].dept === 'college_dept' ? 'College Disciplines' : 'Single Faculty Disciplines'}
                                  </>
                                ) : null}
                                <i className={`${deactiveTab.includes(subject) ? 'bi bi-chevron-down svg-color' : 'bi bi-chevron-up svg-color'}`}></i>
                              </button>
                            </h2>
                            <div
                              className={`accordion-collapse collapse ${deactiveTab.includes(subject) ? '' : 'show'}`}
                              data-bs-parent="#outlineaccordion"
                            >
                              <div className="accordion-body">
                                <div className="table-responsive signal-table">
                                  <table className="table table-hover">
                                    <thead>
                                      <tr className="table-active">
                                        <th scope="col" width="10%">Course Code</th>
                                        <th scope="col" width="20%">Course</th>
                                        <th scope="col" width="15%">Faculty</th>
                                        <th scope="col" width="10%">Discipline</th>
                                        <th scope="col" width="10%">Course Category</th>
                                        <th scope="col" width="15%">Course Type</th>
                                        {department == 3 ? (
                                          <th scope="col" width="15%">Discipline Type</th>
                                        ) : null}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Array.isArray(bvocData[subject]) ? (
                                        bvocData[subject].map((course, courseIndex) => (
                                          <tr key={courseIndex}>
                                            <td>{course.course_code}</td>
                                            <td>{course.course_name}</td>
                                            <td>{course.faculty_name}</td>
                                            <td>{course.discipline_name}</td>
                                            <td>{course.group_name}</td>
                                            <td>{course.college_course_type}</td>
                                            {department == 3 ? (
                                              <td>{course.dept === 'college_dept' ? 'College Disciplines' : 'Single Faculty Disciplines'}</td>
                                            ) : null}
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="3">No courses available for this subject</td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))) : (
                          <div className="txt-aln pdg11">B.Voc data not found</div>
                        )}
                      </div>
                    </div>



                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
